module.exports = __webpack_public_path__ + "static/media/happy-new-year.0135ac7b.svg";